"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const React = __importStar(require("react"));
const logo_styled_1 = __importDefault(require("./logo.styled"));
const logo_emblem_svg_1 = __importDefault(require("./logo-emblem.svg"));
const tn_logo_full_small_svg_1 = __importDefault(require("./tn-logo-full-small.svg"));
const Logo = ({ url, disabled, fullLogo }) => {
    const Tag = !!disabled ? 'span' : 'a';
    const props = !!disabled ? {} : { href: url || '/' };
    const logoAsset = fullLogo ? tn_logo_full_small_svg_1.default : logo_emblem_svg_1.default;
    return React.createElement(logo_styled_1.default, { logoUrl: logoAsset },
        React.createElement(Tag, Object.assign({ "data-testid": `travelnest-logo-${fullLogo ? 'full' : 'emblem'}`, className: "tn-logo" }, props),
            React.createElement("span", { className: "tn-logo__inner" }, "Home")));
};
exports.Logo = Logo;
//# sourceMappingURL=Logo.js.map